module.exports = __webpack_public_path__ + "img/rofus.27ae6cb1.png";